import React from "react";
import { Card, Spin } from "antd";

const cardHeadStylesBase = {
  color: "white",
  backgroundColor: "#22316C",
  height: "40px",
};

const CardWithHeader = ({
  style,
  title,
  loading,
  titleStyle,
  cardHeadStyles,
  children,
  headerChildren,
  childrenWrapperStyles,
}) => {
  return (
    <Spin spinning={Boolean(loading)}>
      <Card
        type="inner"
        className="noPadding"
        headStyle={{ ...cardHeadStylesBase, ...cardHeadStyles }}
        {...{ style }}
        title={
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <span style={titleStyle}>{title}</span>
            {headerChildren}
          </div>
        }
      >
        <div style={childrenWrapperStyles}>{children}</div>
      </Card>
    </Spin>
  );
};

export default CardWithHeader;
